import { Fragment, useEffect, useState } from "react";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import ProductLanding from "./productlanding/ProductLanding";
import Explore from "../home/explore/Explore";
import WOW from "wow.js";

import axios from "axios";
import { baseUrl, getVendorPage, getVendorCategory } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";
import { useLocation, useNavigate } from "react-router-dom";
import VendorFilter from "./vendorFilter/VendorFilter";

const Vendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dd, setDd] = useState(false);
  const [filter, setFilter] = useState("");
  const [vendor, setVendor] = useState({});
  const [loader, setLoader] = useState(false);

  const [vendorCategory, setVendorCategory] = useState([]);
  const [categoryLoader, setCategoryLoader] = useState(false);

  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  // get Vendor Page API
  const getVendorsApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getVendorPage}`);
      if (res?.data?.success) {
        setVendor(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  // Get Vendors Category API

  const getVendorCategoryApi = async () => {
    setCategoryLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getVendorCategory}`);
      if (res?.data?.success) {
        setVendorCategory(res?.data?.data);
        setCategoryLoader(false);
        if (location?.hash) {
          setTimeout(() => {
            const element = document.getElementById(
              `${location.hash.substring(1)}`
            );
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
      setCategoryLoader(false);
    }
  };

  useEffect(() => {
    getVendorsApi();
    getVendorCategoryApi();
  }, []);

  useEffect(() => {
    const element = document.getElementById(location.hash.substring(1));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);

  return (
    <PageLayout>
      {loader || categoryLoader ? (
        <LoaderCard />
      ) : (
        <div
          onClick={() => {
            setDd(false);
          }}
        >
          <ProductLanding
            onClick={() => navigate("/contactus")}
            vendor={vendor}
          />
          <VendorFilter
            dd={dd}
            setDd={setDd}
            dataList={vendorCategory}
            filter={filter}
            setFilter={setFilter}
          />
          {vendorCategory?.length > 0 ? (
            vendorCategory
              ?.filter((ele) => ele?._id.includes(filter))
              ?.map((data) => {
                return (
                  <Fragment key={data?._id}>
                    <Explore
                      title={data?.category_name || "-"}
                      categoryId={data?._id}
                    />
                  </Fragment>
                );
              })
          ) : (
            <p className="text-center my-5 py-5">Category not found...</p>
          )}
        </div>
      )}
    </PageLayout>
  );
};

export default Vendor;
